import Network from '@/services/network'
import { ref } from 'vue'

export default function handleEcommerce() {
    const network = new Network;
    const loading = ref(false)

    const fetchSyncProductList = (query) => {
        return network.api('get', '/ecommerce/sync-product' + query)
    }

    const fetchSyncProductLog = (id, query) => {
        return network.api('get', `/ecommerce/sync-product/${id}` + query)
    }

    const updateSyncProductRow = (id, data) => {
        return network.api('post', `/ecommerce/sync-product/${id}/row`, data)
    }

    const applySyncProductToAll = (id, data) => {
        return network.api('post', `/ecommerce/sync-product/${id}/apply-to-all`, data)
    }

    const rejectSyncProductRow = (id, data) => {
        return network.api('post', `/ecommerce/sync-product/${id}/reject-row`, data)
    }

    const restoreSyncProductRow = (id, data) => {
        return network.api('post', `/ecommerce/sync-product/${id}/restore-row`, data)
    }

    const approveSyncProduct = (id, data) => {
        return network.api('post', `/ecommerce/sync-product/${id}/approve`, data)
    }

    const deleteSyncProductLog = (id, query) => {
        return network.api('delete', `/ecommerce/sync-product/${id}` + query)
    }

    const fetchSyncIntegrations = (query) => {
        return network.api('get', '/ecommerce/sync-management/integrations' + query)
    }

    const triggerIntegrationSyncAction = (integrationId, data) => {
        return network.api('post', `/ecommerce/sync-management/integrations/${integrationId}/sync`, data)
    }

    const fetchSyncLogs = (query) => {
        return network.api('get', '/ecommerce/sync-logs' + query)
    }

    const fetchSyncRuns = (query) => {
        return network.api('get', '/ecommerce/sync-logs/runs' + query)
    }

    const retrySyncItem = (id, data) => {
        return network.api('post', `/ecommerce/sync-logs/${id}/retry`, data)
    }

    return {
        loading,
        fetchSyncProductList,
        fetchSyncProductLog,
        updateSyncProductRow,
        applySyncProductToAll,
        rejectSyncProductRow,
        restoreSyncProductRow,
        approveSyncProduct,
        deleteSyncProductLog,
        fetchSyncIntegrations,
        triggerIntegrationSyncAction,
        fetchSyncLogs,
        fetchSyncRuns,
        retrySyncItem
    }
}
